import React from 'react';
import EvaluacionesCuantitativas1Table from './TableEvaluacionesCuantitativas1/EvaluacionesCuantitativas1';

const EvaluacionesCuantitativas1 = () => {
  return <EvaluacionesCuantitativas1Table/> ;
};

export default EvaluacionesCuantitativas1;
